export default "__VITE_ASSET__vdPZwNDi__"